"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

var _Modal = require("./Modal.styles");

// eslint-disable-next-line import/prefer-default-export
const Content = (0, _styledComponents.default)(_Modal.MediumBody).withConfig({
  displayName: "StatusModalstyles__Content"
})(["display:flex;align-items:center;gap:", ";"], (0, _theme.spacing)(0.5));
exports.Content = Content;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDb250ZW50Iiwic3R5bGVkIiwiTWVkaXVtQm9keSIsInNwYWNpbmciXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Nb2RhbC9TdGF0dXNNb2RhbC5zdHlsZXMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdzdHlsZWQtY29tcG9uZW50cydcbmltcG9ydCB7IHNwYWNpbmcgfSBmcm9tICd+dGhlbWUnXG5pbXBvcnQgeyBCb2R5UHJvcHMsIE1lZGl1bUJvZHkgfSBmcm9tICcuL01vZGFsLnN0eWxlcydcblxuLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIGltcG9ydC9wcmVmZXItZGVmYXVsdC1leHBvcnRcbmV4cG9ydCBjb25zdCBDb250ZW50ID0gc3R5bGVkKE1lZGl1bUJvZHkpPEJvZHlQcm9wcz5gXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGdhcDogJHtzcGFjaW5nKDAuNSl9O1xuYFxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7QUFFQTtBQUNPLE1BQU1BLE9BQU8sR0FBRyxJQUFBQyx5QkFBQSxFQUFPQyxpQkFBUCxDQUFIO0VBQUE7QUFBQSxrREFHWCxJQUFBQyxjQUFBLEVBQVEsR0FBUixDQUhXLENBQWIifQ==